import ControlsDesktopView from './desktop/Controls.desktop.view';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';

export default function ControlsView() {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <ControlsDesktopView />}</>;
}
